// extracted by mini-css-extract-plugin
module.exports = {"responsiveImage":"responsiveImage-module--responsive-image--pzGdo","responsiveImage__image":"responsiveImage-module--responsive-image__image--sRT8U"};